<template>
  <router-view v-if="$route.name === 'waybillDetail'"></router-view>
  <content-view class="waybillList" v-else>
    <template slot="header">
      <reset-search class="pb32 pt16" ref="pa" :form.sync="form">
        <table class="wh-form wh-form_full">
          <tbody>
            <tr>
              <td width="70">运单状态：</td>
              <td>
                <a-select v-model="form.status" placeholder="请选择">
                  <a-select-option value="1">待调度</a-select-option>
                  <a-select-option value="2">待派单</a-select-option>
                  <a-select-option value="3">待接单</a-select-option>
                  <a-select-option value="4">运输中</a-select-option>
                  <a-select-option value="5">已完成</a-select-option>
                  <a-select-option value="6">异常</a-select-option>
                  <a-select-option value="7">取消</a-select-option>
                </a-select>
              </td>
              <td width="70">运单号：</td>
              <td>
                <a-input v-model="form.serial" placeholder="请输入"></a-input>
              </td>
            </tr>
            <tr>
              <td width="98">司机号码：</td>
              <td>
                <a-input v-model="form.phone" placeholder="请输入"></a-input>
              </td>

              <td colspan="3"></td>
              <td class="text-right">
                <a-button @click="reset" class="mr8">重 置</a-button>
                <a-button type="primary" @click="search">查 询</a-button>
              </td>
            </tr>
          </tbody>
        </table>
      </reset-search>
    </template>
    <div class="bg-white pl32 pr32 pt32">
      <h4 class="waybillList-title">运单列表</h4>

      <!-- <div class="mt16">
        <a-button
          type="primary"
          class="mr8"
          @click="startTask"
          :disabled="$route.meta.role.start"
          >导 出</a-button
        >
        <a-button
          class=""
          @click="
            getExportList();
            listVisible = true;
          "
          >导出任务列表</a-button
        >
      </div> -->
      <a-table
        :columns="columns"
        :dataSource="orderList"
        bordered
        class="mt24"
        :pagination="pagination"
        rowKey="serial"
        @change="paginationChange"
        :scroll="{ x: true }"
      >
        <template slot="orderType" slot-scope="text">
          <i
            class="exportStatusIcon"
            v-if="text * 1 === 1 || text * 1 === 2 || text * 1 === 3"
          ></i>
          <i
            class="exportStatusIcon exportStatusIconBlue"
            v-if="text * 1 === 4"
          ></i>
          <i
            class="exportStatusIcon exportStatusIconsucc"
            v-if="text * 1 === 5"
          ></i>
          <i
            class="exportStatusIcon exportStatusIconerr"
            v-if="text * 1 === 6"
          ></i>
          <i
            class="exportStatusIcon exportStatusIconOver"
            v-if="text * 1 === 7"
          ></i>
          {{ text | skipType }}
        </template>
        <template slot="scrap" slot-scope="text, record">
          {{ Array.isArray(text) ? text.join("、") : "" }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a class="btn btn_text" @click="detail(text.id)">查看</a>
        </template>
      </a-table>
      <!-- 导出任务列表 -->
      <a-modal
        :visible="listVisible"
        @ok="handleOk"
        :confirmLoading="confirmLoading"
        @cancel="handleCancel"
        :width="modalWidth"
      >
        <template slot="title"
          ><span class="orderSortingList-title">数据导出任务列表</span>
        </template>
        <div>
          <a-table
            :columns="exportColumns"
            :dataSource="exportList"
            bordered
            class="mt16"
            :pagination="exportPagination"
            @change="exportChange"
          >
            <template slot="createdTime" slot-scope="text">
              {{ $moment.unix(text).format("YYYY-MM-DD HH:mm") }}
            </template>
            <template slot="status" slot-scope="text">
              <i
                class="exportStatusIcon"
                :class="
                  text != 1
                    ? text == 2
                      ? 'exportStatusIconBlue'
                      : 'exportStatusIconsucc'
                    : ''
                "
              ></i
              >{{ text == 1 ? "未开始" : text == 2 ? "导出中" : "已完成" }}
            </template>
            <template slot="operation" slot-scope="text, record">
              <a
                class="btn btn_text"
                v-if="text.status == 3"
                @click="download(text.path)"
                >下 载</a
              >
              <a @click="cancel(text.id)" class="btn btn_text" v-else>取 消</a>
            </template>
          </a-table>
        </div>
      </a-modal>
    </div>
  </content-view>
</template>
<script>
export default {
  name: "waybillList",
  data() {
    return {
      form: {},
      columns: [
        {
          //
          title: "运单号",
          dataIndex: "serial",
          fixed: "left",
          width: 210,
        },
        {
          title: "订单状态",
          dataIndex: "status",
          fixed: "left",
          width: 100,
          scopedSlots: { customRender: "orderType" },
        },
        {
          //
          title: "分拣中心",
          dataIndex: "sorting_name",
          width: 200,
        },
        {
          //
          title: "分拣中心电话",
          dataIndex: "sorting_phone",
        },
        {
          //
          title: "货物名称",
          dataIndex: "scrap",
          scopedSlots: { customRender: "scrap" },
        },
        {
          //
          title: "分配司机",
          dataIndex: "driver_name",
          // scopedSlots: { customRender: "type" }
        },
        {
          //
          title: "司机电话",
          dataIndex: "driver_phone",
          // scopedSlots: { customRender: "type" }
        },
        {
          //
          title: "车牌",
          dataIndex: "driver_car_number",
          // scopedSlots: { customRender: "type" }
        },
        {
          //
          title: "所需车型",
          dataIndex: "car_type",
        },
        {
          //
          title: "重量",
          dataIndex: "weight",
        },
        {
          //
          title: "代收货款",
          dataIndex: "",
        },
        {
          //
          title: "增值服务",
          dataIndex: "",
        },

        {
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "operation" },
          width: 160,
          fixed: "right",
        },
      ],
      exportColumns: [
        {
          title: "任务名称",
          dataIndex: "name",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          scopedSlots: { customRender: "createdTime" },
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "operation" },
        },
      ],
      pagination: {
        //默认当前页
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal() {
          return `共 ${this.total} 条数据`;
        },
        showSizeChanger: true,
        total: 0,
      },
      exportPagination: {
        defaultCurrent: 1,
        defaultPageSize: 6,
        pageSizeOptions: ["6", "10", "15"],
        showTotal() {
          return `共 ${this.total} 条数据`;
        },
        showSizeChanger: true,
        total: 0,
      },
      page: 1,
      page_num: 10,
      orderList: [],
      centerId: "",
      listVisible: false,
      exportList: [],
      modalWidth: 800,
      exportPage: 1,
      exportPage_num: 10,
      confirmLoading: false,
      exportPage: 1,
      exportPage_num: 10,
    };
  },
  components: {},
  methods: {
    // 头部数据重置
    reset() {
      this.page = 1;
      this.page_num = 10;
      this.$set(this.pagination, "current", 1);
      this.$set(this.pagination, "pageSize", 10);
      this.$refs.pa.reset();
      this.getList();
    },
    //查询
    search() {
      this.$set(this.pagination, "current", 1);
      this.$set(this.pagination, "pageSize", 10);
      this.page = 1;
      this.page_num = 10;
      this.getList(true);
    },
    //详情
    detail(id) {
      this.$router.push({
        name: "waybillDetail",
        query: {
          id: id,
          page: this.page,
          limit: this.page_num,
        },
      });
    },
    //派车
    dispatch(id, type) {
      this.$router.push({
        name: "dispatch",
        query: {
          id: id,
          type: type,
          page: this.page,
          limit: this.page_num,
        },
      });
    },
    //点击导出按钮
    startTask() {
      console.log(this.form);
      let form = this.$utils.deepClone(this.form);
      delete form.page_num;
      delete form.page;
      this.$api.order.waybillIndexStartTask(this.form).then((res) => {
        if (res.data) {
          this.$message.success("成功加入导出任务列表!");
        }
        console.log(res);
      });
    },
    // 弹框-数据导出任务列表确认按钮
    handleOk(e) {
      this.listVisible = false;
    },
    // 弹框-数据导出任务列表取消按钮
    handleCancel(e) {
      this.listVisible = false;
    },
    //获得导出任务列表
    getExportList() {
      let s = {};
      s.page = this.exportPage;
      s.page_num = this.exportPage_num;
      s.excel_type = 68;
      this.$api.common.excelList(s).then((res) => {
        console.log(res);
        this.exportPagination.total = res.total * 1;
        this.exportList = res.data.list;
      });
    },
    //导出任务列表分页
    exportChange(pagination) {
      this.$set(this.exportPagination, "current", pagination.current);
      this.$set(this.exportPagination, "pageSize", pagination.pageSize);
      this.exportPage = pagination.current;
      this.exportPage_num = pagination.pageSize;
      this.getExportList();
    },
    //下载任务
    download(path) {
      window.open(path);
    },
    //取消下载任务
    cancel(id) {
      this.$http;
      this.$api.common.deleteExcel({ id: id }).then((res) => {
        this.$message.success("取消下载任务成功！");
        this.getExportList();
      });
    },
    getList(status = false) {
      this.form.page = this.page;
      this.form.page_num = this.page_num;
      this.$api.order.billList(this.form).then((res) => {
        this.pagination.total = res.total * 1;
        this.orderList = res.data.list;
        status ? this.$message.success("共查询到" + res.total + "条信息") : "";
      });
    },
    /**
     * 分页变化回调
     * @param pagination 当前分页器信息
     */
    paginationChange(pagination) {
      this.$set(this.pagination, "current", pagination.current);
      this.$set(this.pagination, "pageSize", pagination.pageSize);
      this.page = pagination.current;
      this.page_num = pagination.pageSize;
      this.getList();
    },
    //确认删除
    confirm() {
      this.$api.order
        .billCancel({ transport_id: this.centerId })
        .then((res) => {
          this.$message.success("取消运单成功！");
          this.getList();
        });
    },
    cancel() {},
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route(val, oldVal) {
      if (oldVal.name == "waybillDetail" || oldVal.name == "dispatch") {
        this.page = oldVal.query.page;
        this.page_num = oldVal.query.limit;
        this.pagination.defaultCurrent = this.page;
        this.pagination.defaultPageSize = this.page_num;
        this.getList();
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.waybillList {
  &-title {
    color: $title-color-black-85;
    @include pxAndLh(16);
    font-weight: bold;
  }
  .ant-calendar-picker {
    width: 100%;
  }
  .exportStatusIcon {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 8px;
    vertical-align: middle;
    margin-top: -4px;
    background: $type-color-dark;
  }
  .exportStatusIconBlue {
    background: $type-color-deep;
  }
  .exportStatusIconsucc {
    background: $type-color-succe;
  }
  .exportStatusIconerr {
    background: $type-color-error;
  }
  .exportStatusIconOver {
    background: $type-color-light;
  }
}
</style>
